// extracted by mini-css-extract-plugin
export default {"root":"MainContainer_root__zviDT","content":"MainContainer_content__AAaCN","footer":"MainContainer_footer__XvboH","link":"MainContainer_link__wbOXA"};